export const ASK_REPAIR = "How can I make it better?";

export const SORRY_STEPS = [
  {
    key: "problem",
    kind: "problem",
    name: "State the problem",
    title: "Step into their shoes",
    help: "Say how they probably feel and what you did. This is empathy and owning it.",
    examples: {
      kid: [["sad", "took your toy without asking"], ["hurt", "said something mean"], ["left out", "didn't let you play"]],
    },
  },
  {
    key: "sorry",
    starter: "",
    name: "Make the apology",
    title: "Now say “I'm sorry”",
    help: "On its own, “sorry” can feel empty. After step 1, it really means something. Say it like you mean it.",
    examples: { kid: ["I'm sorry.", "I'm really sorry."] },
  },
  {
    key: "repair",
    starter: "To make it better, I will",
    name: "Do the repair work",
    title: "Make it better",
    help: "This is the only way an apology is complete. Not sure how? Ask them!",
    examples: {
      kid: ["give it back and ask first next time.", "help you fix it.", "play with you now."],
    },
  },
];

export const gentleHint = (text) => {
  if (/\bbut\b/i.test(text)) return "A true apology doesn't need a “but”. Try leaving that part out.";
  if (/sorry if you/i.test(text)) return "Try owning it: say what you did, instead of “sorry if you…”.";
  return "";
};

export const hasSorry = (t) => /\bsorry\b/i.test(t);

export const problemSentence = (feel, did) => `You probably feel ${feel.trim()}, because I ${did.trim()}`.replace(/[.\s]*$/, ".");

export const repairSentence = (v) => {
  const t = v.trim();
  if (t === ASK_REPAIR) return t;
  return `To make it better, I will ${t.replace(/^to make it better,?\s*i will\s*/i, "")}`;
};
